import {BaseBilling} from 'app/components/entities/billing/base/model';
import {apiClient} from 'app/components/shared';

export class BaseBillingApi {
  static async validateCoupon(teamId: string, coupon: string) {
    return apiClient.post<BaseBilling.Coupon | BaseBilling.InvalidCoupon>(
      `/front/api/v1t/team/${teamId}/teams/${teamId}/billing/coupon/validate`,
      {
        id: coupon,
      },
    );
  }

  static async applyCoupon(teamId: string, coupon: string): Promise<void> {
    return apiClient.post(`/front/api/v1t/team/${teamId}/teams/${teamId}/billing/coupon/activate`, {
      id: coupon,
    });
  }

  static getInvoiceUrl(teamId: string, invoiceId: string): string {
    return `/front/api/v1t/team/${teamId}/billing/v2/invoice/${invoiceId}/pdf`;
  }
}
